module.exports = __webpack_public_path__ + "static/media/blue.3e61a401.svg";